// frontend/src/presentation/speech/sttDiagStore.ts
//
// Boczny kanał telemetrii dyktowania offline (Vosk) — bliźniak `voskModelStore`.
// `useDictation` (seam integracyjny, „zamrożony" wzorcem Strangler) formatuje
// zdarzenia `SpeechDiagnosticEvent` na jednolinijkowe wpisy i wrzuca je tutaj;
// `<SttDiagnosticsOverlay/>` w Screen1 renderuje je NA EKRANIE, gdy włączona
// jest flaga `?sttdiag=1`. To jest „krok 7" walidacji FAZY 1 — realny telefon
// zleceniodawcy w hałasie hali, bez laptopa i `chrome://inspect` przy maszynie:
// pracownik czyta / robi screenshot panelu, a my uczymy się empirycznie
// (`inputSampleRate`, `sawAudioSignal`, pierwszy `partialresult`, transkrypt,
// czasy). Console (`[STT-DIAG]`) leci ZAWSZE — panel to tylko druga droga.
//
// Wzorzec `useSyncExternalStore`: `subscribe` + `getSnapshot` (referencyjnie
// stabilny między zmianami) + imperatywne `push` / `setTranscript` / `clear`.

/** Migawka dziennika diagnostycznego. `lines` rośnie, `transcript` się nadpisuje. */
export interface SttDiagSnapshot {
  lines: readonly string[]
  transcript: string
}

/** Ile ostatnich wpisów trzymamy (jedna sesja dyktowania to ~7–10 zdarzeń). */
const MAX_LINES = 60

let snapshot: SttDiagSnapshot = { lines: [], transcript: '' }
const listeners = new Set<() => void>()

function emit(): void {
  for (const listener of listeners) listener()
}

/** `HH:MM:SS.mmm` z bieżącego czasu — porządkuje wpisy w panelu i w screenshotcie. */
function stamp(): string {
  return new Date().toISOString().slice(11, 23)
}

export const sttDiagStore = {
  /** Dopisuje wpis (ze znacznikiem czasu) i budzi subskrybentów. */
  push(line: string): void {
    const next = [...snapshot.lines, `${stamp()} ${line}`]
    snapshot = {
      lines: next.length > MAX_LINES ? next.slice(next.length - MAX_LINES) : next,
      transcript: snapshot.transcript,
    }
    emit()
  },
  /** Ustawia „na żywo" transkrypt bieżącej sesji (bez zaśmiecania `lines`). */
  setTranscript(text: string): void {
    if (text === snapshot.transcript) return
    snapshot = { lines: snapshot.lines, transcript: text }
    emit()
  },
  /** Czyści panel (przycisk „Wyczyść" w overlayu). */
  clear(): void {
    snapshot = { lines: [], transcript: '' }
    emit()
  },
  getSnapshot(): SttDiagSnapshot {
    return snapshot
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
  /** Wyłącznie dla testów — przywraca stan początkowy. */
  _reset(): void {
    snapshot = { lines: [], transcript: '' }
    listeners.clear()
  },
}
